import { useCallback, useEffect, useState } from "react";
import { getInspectionLogs } from "../../services/api";

export const useInspectionLog = (
  startDateTime: string,
  stopDateTime: string
) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [inspectionLogs, setInspectionLogs] = useState([]);
  const [error, setError] = useState<null | Error>(null);

  const getInspectionData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getInspectionLogs(startDateTime, stopDateTime);
      setInspectionLogs(response?.data);
    } catch (error) {
      setError(error as Error);
    } finally {
      setLoading(false);
    }
  }, [startDateTime, stopDateTime]);

  useEffect(() => {
    getInspectionData();
  }, [getInspectionData]);

  return { inspectionLogs, loading, error };
};
